/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckPhoneExistsModel,
  CheckPhoneNumberResult,
  ExchangeAdminTokenCommandResult,
  ExchangeAdminTokenModel,
  GetAuthClaimsResult,
  InitiateVerificationResult,
  LoginModel,
  ProblemDetails,
  VerifyLoginModel,
  VerifyLoginResponse
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Check if a platform_user with a specific phone_number exists on this platform
 */
export const checkIfExists = (
    checkPhoneExistsModel: CheckPhoneExistsModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<CheckPhoneNumberResult>(
      {url: `/api/v1/auth/exists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkPhoneExistsModel, signal
    },
      options);
    }
  


export const getCheckIfExistsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkIfExists>>, TError,{data: CheckPhoneExistsModel}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof checkIfExists>>, TError,{data: CheckPhoneExistsModel}, TContext> => {

const mutationKey = ['checkIfExists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkIfExists>>, {data: CheckPhoneExistsModel}> = (props) => {
          const {data} = props ?? {};

          return  checkIfExists(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CheckIfExistsMutationResult = NonNullable<Awaited<ReturnType<typeof checkIfExists>>>
    export type CheckIfExistsMutationBody = CheckPhoneExistsModel
    export type CheckIfExistsMutationError = ErrorType<unknown>

    /**
 * @summary Check if a platform_user with a specific phone_number exists on this platform
 */
export const useCheckIfExists = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkIfExists>>, TError,{data: CheckPhoneExistsModel}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof checkIfExists>>,
        TError,
        {data: CheckPhoneExistsModel},
        TContext
      > => {
      return useMutation(getCheckIfExistsMutationOptions(options));
    }
    /**
 * @summary Initiates login request for phone number verification.
 */
export const authLogIn = (
    loginModel: LoginModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<InitiateVerificationResult | void>(
      {url: `/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginModel, signal
    },
      options);
    }
  


export const getAuthLogInMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogIn>>, TError,{data: LoginModel}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof authLogIn>>, TError,{data: LoginModel}, TContext> => {

const mutationKey = ['authLogIn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogIn>>, {data: LoginModel}> = (props) => {
          const {data} = props ?? {};

          return  authLogIn(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AuthLogInMutationResult = NonNullable<Awaited<ReturnType<typeof authLogIn>>>
    export type AuthLogInMutationBody = LoginModel
    export type AuthLogInMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Initiates login request for phone number verification.
 */
export const useAuthLogIn = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogIn>>, TError,{data: LoginModel}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof authLogIn>>,
        TError,
        {data: LoginModel},
        TContext
      > => {
      return useMutation(getAuthLogInMutationOptions(options));
    }
    /**
 * @summary Verifies a user's phone number and creates a platform_user.
 */
export const authVerifyLogin = (
    verifyLoginModel: VerifyLoginModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<VerifyLoginResponse>(
      {url: `/api/v1/auth/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyLoginModel, signal
    },
      options);
    }
  


export const getAuthVerifyLoginMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifyLogin>>, TError,{data: VerifyLoginModel}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof authVerifyLogin>>, TError,{data: VerifyLoginModel}, TContext> => {

const mutationKey = ['authVerifyLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authVerifyLogin>>, {data: VerifyLoginModel}> = (props) => {
          const {data} = props ?? {};

          return  authVerifyLogin(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type AuthVerifyLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authVerifyLogin>>>
    export type AuthVerifyLoginMutationBody = VerifyLoginModel
    export type AuthVerifyLoginMutationError = ErrorType<ProblemDetails>

    /**
 * @summary Verifies a user's phone number and creates a platform_user.
 */
export const useAuthVerifyLogin = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authVerifyLogin>>, TError,{data: VerifyLoginModel}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof authVerifyLogin>>,
        TError,
        {data: VerifyLoginModel},
        TContext
      > => {
      return useMutation(getAuthVerifyLoginMutationOptions(options));
    }
    /**
 * @summary Exchanges admin app token for patient app token.
 */
export const exchangeAdminToken = (
    exchangeAdminTokenModel: ExchangeAdminTokenModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ExchangeAdminTokenCommandResult>(
      {url: `/api/v1/auth/exchange-admin-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exchangeAdminTokenModel, signal
    },
      options);
    }
  


export const getExchangeAdminTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeAdminToken>>, TError,{data: ExchangeAdminTokenModel}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof exchangeAdminToken>>, TError,{data: ExchangeAdminTokenModel}, TContext> => {

const mutationKey = ['exchangeAdminToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exchangeAdminToken>>, {data: ExchangeAdminTokenModel}> = (props) => {
          const {data} = props ?? {};

          return  exchangeAdminToken(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ExchangeAdminTokenMutationResult = NonNullable<Awaited<ReturnType<typeof exchangeAdminToken>>>
    export type ExchangeAdminTokenMutationBody = ExchangeAdminTokenModel
    export type ExchangeAdminTokenMutationError = ErrorType<unknown>

    /**
 * @summary Exchanges admin app token for patient app token.
 */
export const useExchangeAdminToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeAdminToken>>, TError,{data: ExchangeAdminTokenModel}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof exchangeAdminToken>>,
        TError,
        {data: ExchangeAdminTokenModel},
        TContext
      > => {
      return useMutation(getExchangeAdminTokenMutationOptions(options));
    }
    /**
 * @summary Gets claims for authenticated caller.
 */
export const getAuthClaims = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetAuthClaimsResult>(
      {url: `/api/v1/auth/claims`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAuthClaimsQueryKey = () => {
    return [
    `/api/v1/auth/claims`
    ] as const;
    }

    
export const getGetAuthClaimsQueryOptions = <TData = Awaited<ReturnType<typeof getAuthClaims>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthClaims>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthClaimsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthClaims>>> = ({ signal }) => getAuthClaims(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAuthClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthClaims>>>
export type GetAuthClaimsQueryError = ErrorType<unknown>


/**
 * @summary Gets claims for authenticated caller.
 */

export function useGetAuthClaims<TData = Awaited<ReturnType<typeof getAuthClaims>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAuthClaims>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAuthClaimsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




